var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 918.82 713.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-6,.cls-9{fill:none;}.cls-2,.cls-9{stroke:#0b0c0d;}.cls-2{stroke-miterlimit:10;}.cls-2,.cls-6,.cls-9{stroke-width:2px;}.cls-3{fill:#c1c532;}.cls-4{fill:#d83c39;}.cls-5{fill:#f7ab00;}.cls-6{stroke:#fff;}.cls-6,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-7{fill:#fdf2e3;}.cls-8{fill:#6f61c5;}.cls-10{clip-path:url(#clip-path);}.cls-11{fill:#fff;}.cls-12{fill:#0b0c0d;}.cls-13{fill:#d2a165;}.cls-14{fill:#ebc79b;}.cls-15{fill:#1b2125;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "449.75 75.47 486.86 362.47 581.94 362.47 581.94 75.47 449.75 75.47"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "96.18 710.78 96.18 6.25 337.42 6.25 337.42 710.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.9,
    y1: 162,
    x2: 335.88,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.9,
    y1: 370.5,
    x2: 335.88,
    y2: 370.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.51,
    y: 87.1,
    width: 169.2,
    height: 30.21,
    rx: 3.67,
    transform: "translate(464.23 204.41) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 295.97,
    y: 87.1,
    width: 8.51,
    height: 30.21,
    transform: "translate(600.44 204.41) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 160.61,
    y: 87.1,
    width: 8.51,
    height: 30.21,
    transform: "translate(329.72 204.41) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.25,
    y: 117.22,
    width: 149.06,
    height: 43.91,
    rx: 4.58,
    transform: "translate(415.56 278.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 167.7,
    y: 128.76,
    width: 78.53,
    height: 21.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M276.73,56.81h-139V83.55h139a13.18,13.18,0,0,0,13.18-13.18V70A13.18,13.18,0,0,0,276.73,56.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M293.29,69.69A17.16,17.16,0,0,0,276,53.26H133.79l0,0a4.81,4.81,0,0,0,4.81,4.81H276.06a12.3,12.3,0,0,1,12.4,11.64,12.1,12.1,0,0,1-12.08,12.53H138.58a4.81,4.81,0,0,0-4.81,4.81s0,0,0,0H276.38A16.94,16.94,0,0,0,293.29,69.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M282.25,80.87s-6.6-9.16,0-21.1c0,0,7.35,2.43,6.14,12.78A11.66,11.66,0,0,1,282.25,80.87Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 137.71,
    y1: 62.6,
    x2: 280.9,
    y2: 62.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 137.71,
    y1: 70.18,
    x2: 279.04,
    y2: 70.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 137.71,
    y1: 77.76,
    x2: 280.9,
    y2: 77.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "213.81 74.46 209.24 72.02 204.68 74.46 204.68 62.6 213.81 62.6 213.81 74.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.54,358.3H220.36c4.63-6.77,7.82-21.12,7.82-37.73s-3.23-31.11-7.9-37.83l.11-6.29c5.33-1.92,15-8.31,15-14.3H194.08c0,6.46,8.32,11.88,14.32,13.39l0,7.14c-4.7,6.7-7.95,21.15-7.95,37.89s3.2,31,7.83,37.73H184.14c-9.41,0-17,1.58-17,11h94.49C261.59,359.88,254,358.3,244.54,358.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 216.65,
    cy: 195.6,
    r: 13.87,
    transform: "translate(-20.4 365.92) rotate(-77.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "184.81 189.39 151.42 269.17 276.2 269.17 249.47 189.39 184.81 189.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167.1,367.59s3.33-4.16,7.08,0c0,0,3.19-4.19,7,0,0,0,3.77-4.31,7.1,0,0,0,3.34-4.24,6.64,0,0,0,3.71-4.47,6.94,0,0,0,3.67-3.93,6.55,0,0,0,3.43-3.66,6.87,0,0,0,4.39-4.31,8.22,0,0,0,5.12-4.89,9.18,0,0,0,3.92-4.45,7.39,0,0,0,4-4.39,7.34,0,0,0,3.69-4.56,7.28,0,0,0,4.26-3.58,6.88,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.07,288.23s13,31.35-2.28,66.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 204.51,
    y1: 269.29,
    x2: 211.88,
    y2: 200.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 201.46,
    y1: 200.68,
    x2: 188.32,
    y2: 269.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 169.82,
    y1: 269.29,
    x2: 193.11,
    y2: 200.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 225.19,
    y1: 269.29,
    x2: 217.81,
    y2: 200.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 228.24,
    y1: 200.68,
    x2: 241.38,
    y2: 269.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 260.14,
    y1: 270.07,
    x2: 236.59,
    y2: 200.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 187.06,
    y1: 195.6,
    x2: 247.16,
    y2: 195.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "406.47 710.78 406.47 6.25 793.88 6.25 793.88 710.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M595.37,67.78,516.28,35.89,436.35,67.77a5,5,0,0,0,1.83,9.57H593.51A5,5,0,0,0,595.37,67.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M516.24,35.89l-.13-11a4.33,4.33,0,0,1,4.37-4.36h0a9.76,9.76,0,1,0-9.26-13.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "449.75 75.47 486.86 362.47 581.94 362.47 581.94 75.47 449.75 75.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M592.83,273.69c-18.65,0-37.57-12.35-46.35-30.4-8.23-17-8.16-38.5.2-57.65,1.77-4,3.89-8,6-11.85,3.64-6.79,7.4-13.81,9.2-21.37A45.24,45.24,0,0,0,559.31,124a91.43,91.43,0,0,0-4.58-8.72A80.83,80.83,0,0,1,549.49,105c-5.82-14.86-1.47-33.42,10.36-44.14l.78.86c-11.48,10.4-15.71,28.43-10,42.86a78.4,78.4,0,0,0,5.16,10.13,93.57,93.57,0,0,1,4.63,8.83A46.42,46.42,0,0,1,563,152.69c-1.84,7.7-5.63,14.79-9.31,21.65-2,3.82-4.16,7.76-5.91,11.77-8.22,18.83-8.3,40-.21,56.67,8.77,18,27.85,30.26,46.46,29.73l0,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M592,248.8c-6-2.43-13.61-5.92-19.69-11.38-6.32-5.69-10.08-12.76-10.58-19.9C561,207.4,566.81,198,572,189.64l.07-.12c6.53-10.55,13.36-22.88,11.76-35.66-.8-6.33-3.65-12.27-6.4-18-1.14-2.35-2.31-4.79-3.33-7.23a75.73,75.73,0,0,1,.63-58.73l1.07.47a74.47,74.47,0,0,0-.62,57.81c1,2.41,2.17,4.84,3.29,7.18,2.8,5.82,5.69,11.84,6.51,18.36,1.65,13.16-5.28,25.7-11.92,36.42l-.07.12c-5.31,8.58-10.79,17.44-10.11,27.19.47,6.74,4.19,13.71,10.2,19.11s13.47,8.78,19.35,11.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M497.19,155.57h-.4c-5.43-.17-8.68-4.1-11.29-7.76-2.4-3.36-4.6-7.12-6.73-10.75-3.65-6.21-7.42-12.64-12.34-17.47a34.66,34.66,0,0,0-21.33-9.68l.09-1.16a35.85,35.85,0,0,1,22.06,10c5,4.94,8.84,11.44,12.52,17.71,2.12,3.61,4.31,7.35,6.67,10.66s5.48,7.13,10.39,7.28a15,15,0,0,0,9-3c7.41-5.27,9.27-13.54,9.53-19.54a78.9,78.9,0,0,0-.87-12.83c-.82-6.73-1.67-13.68.29-20.45a37.74,37.74,0,0,1,6.46-12.07,74.06,74.06,0,0,1,18.93-17.76l.64,1A72.84,72.84,0,0,0,522.14,87.2a36.67,36.67,0,0,0-6.27,11.7c-1.9,6.53-1.06,13.37-.25,20a79.73,79.73,0,0,1,.87,13c-.27,6.26-2.22,14.89-10,20.43A16.36,16.36,0,0,1,497.19,155.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M492.51,136.74a5.21,5.21,0,0,1-2.87-.81,9,9,0,0,1-3.06-4.35c-.76-1.84-1.45-3.73-2-5.62-.36-1.15-.68-2.3-1-3.46a65.63,65.63,0,0,0-2.06-6.47A33.26,33.26,0,0,0,444.69,95.5l-.2-1.15a34.45,34.45,0,0,1,38.06,21.25,67.11,67.11,0,0,1,2.1,6.59c.32,1.14.65,2.29,1,3.42.58,1.86,1.26,3.72,2,5.52a8,8,0,0,0,2.62,3.83c2,1.28,4.65.47,6.12-1a9.06,9.06,0,0,0,2.23-6.53c0-3.64-1.39-7.15-2.67-10.17-.68-1.6-1.39-3.2-2.11-4.79a111.08,111.08,0,0,1-4.59-11.37c-2.08-6.54-2.49-12.43-1.22-17.51,1.59-6.31,5.94-11.31,11.35-13l.35,1.11c-5,1.58-9.1,6.37-10.57,12.2-1.22,4.87-.82,10.55,1.2,16.87A107,107,0,0,0,494.91,112c.72,1.61,1.44,3.21,2.12,4.82,1.32,3.11,2.73,6.76,2.77,10.61a10.28,10.28,0,0,1-2.57,7.35A6.71,6.71,0,0,1,492.51,136.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M597.79,303.84c-9.61-.75-18.39-5-25-8.63-41.91-23.07-49-42.82-50.65-55.66-3-23.44,1.5-47.72,12.48-66.61l.89-1.53c3.39-5.8,6.9-11.8,8.82-18.28a31.69,31.69,0,0,0-1.57-22.52c-1.61-3.4-5-7.41-8.61-8.2a5.93,5.93,0,0,0-5.29,1.46c-4,3.37-4,10.72-3.94,16.63,0,1.68,0,3.26-.07,4.64-.48,7.79-1.43,16.68-6.7,23.64a25.46,25.46,0,0,1-35.3,4c-3.49-2.92-6.06-6.74-8.54-10.43-1.33-2-2.7-4-4.18-5.85a44.7,44.7,0,0,0-25.75-15.72l.23-1.13a45.82,45.82,0,0,1,26.43,16.12c1.51,1.9,2.89,4,4.23,5.93,2.44,3.63,5,7.38,8.32,10.19a24.33,24.33,0,0,0,33.64-3.8c5.06-6.7,6-15.39,6.46-23,.08-1.34.08-2.91.07-4.57,0-6.14,0-13.79,4.35-17.51a7,7,0,0,1,6.28-1.72c4,.88,7.64,5.08,9.42,8.85a32.74,32.74,0,0,1,1.63,23.34c-2,6.61-5.5,12.68-8.92,18.54l-.89,1.53c-10.86,18.67-15.36,42.68-12.34,65.87,3.43,26.3,30.21,43.87,50.06,54.79,6.47,3.57,15.11,7.75,24.49,8.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M559.44,378.69a136.7,136.7,0,0,0-28.26-31.62c-2.5-2-5.13-4-7.67-6-8.15-6.22-16.59-12.64-22.15-21.4-7.58-11.94-9.55-28.49-5.39-45.41.6-2.47,1.33-4.94,2-7.33.77-2.63,1.57-5.34,2.2-8,3.09-13.13,2.52-26.17-1.65-37.72-4.47-12.4-13.26-22.78-24.11-28.5-2.69-1.41-5.56-2.58-8.33-3.71-2.53-1-5.15-2.1-7.64-3.35-6.39-3.23-10.69-7.26-12.77-12l1.06-.47c2,4.48,6.09,8.32,12.24,11.42,2.44,1.23,5,2.29,7.55,3.31,2.8,1.14,5.7,2.33,8.43,3.76,11.11,5.85,20.09,16.47,24.66,29.13,4.25,11.77,4.83,25,1.69,38.38-.64,2.73-1.44,5.46-2.21,8.1-.7,2.38-1.42,4.84-2,7.28-4.08,16.62-2.16,32.84,5.25,44.51,5.45,8.59,13.8,14.95,21.88,21.11,2.55,1.94,5.18,3.95,7.69,6a137.55,137.55,0,0,1,28.51,31.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M521.67,371.87c-3-9.69-9.36-19-19-27.66a115.71,115.71,0,0,0-9.65-7.52c-2.18-1.58-4.44-3.21-6.58-4.93-6.69-5.34-10.79-10.43-12.89-16-3.06-8.13-2.13-17.77,2.91-30.34.86-2.13,1.79-4.29,2.68-6.37,3.11-7.21,6.32-14.66,7.1-22.5a38.22,38.22,0,0,0-35.84-42l.07-1.16a39.38,39.38,0,0,1,36.93,43.25c-.81,8-4.05,15.56-7.19,22.85-.89,2.08-1.82,4.23-2.67,6.35-4.93,12.28-5.85,21.65-2.9,29.49,2,5.37,6,10.3,12.53,15.52,2.12,1.69,4.36,3.32,6.54,4.89a116.59,116.59,0,0,1,9.74,7.6c9.76,8.8,16.25,18.28,19.29,28.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599.77,361.77a93.88,93.88,0,0,0-37.33-32.37c-4-1.95-8.18-3.62-12.25-5.25-7.49-3-15.23-6.08-22-11-11.36-8.29-19.92-21.88-13.43-33.53,1.69-3.05,3.89-4.79,6.54-5.18,4.72-.68,9.46,3.13,11.86,5.47,2.25,2.2,4.34,4.61,6.35,6.95.82,1,1.64,1.91,2.48,2.86,4.61,5.2,9.84,11.1,16,15.58,8.25,6,24.36,15,39.47,8.12l.48,1.06c-15.65,7.13-32.18-2.11-40.64-8.24-6.26-4.55-11.54-10.5-16.19-15.75-.84-.95-1.67-1.91-2.49-2.87-2-2.32-4.06-4.72-6.28-6.88s-6.65-5.77-10.88-5.15c-2.27.34-4.19,1.88-5.7,4.59-7,12.61,4.94,26.07,13.1,32,6.6,4.83,14.28,7.89,21.71,10.85,4.08,1.63,8.3,3.32,12.32,5.28a95,95,0,0,1,37.78,32.77Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "449.75 75.47 467.83 360.96 486.86 362.47 449.75 75.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 553.12,
    y1: 75.47,
    x2: 553.12,
    y2: 362.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M773.44,63.33,700,33.72,625.8,63.32a4.6,4.6,0,0,0,1.71,8.88H771.72A4.6,4.6,0,0,0,773.44,63.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M700,33.72l-.12-10.21a4,4,0,0,1,4.06-4.05H704A9.07,9.07,0,1,0,695.36,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M775.4,193.81c1.86-29.8-16.54-85.46-25.88-112.72h-105s-22.24,87.23-20.65,112.72l-.14,72.28s71.44,22.87,151.84,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 642.79,
    y: 109.01,
    width: 33.28,
    height: 7.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 719.64,
    y: 109.06,
    width: 33.28,
    height: 7.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "751.48 87.39 642.79 87.11 646.72 71.23 746.55 71.58 751.48 87.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M712.11,93.6h-25a11,11,0,0,1-10.94-10.94V76.75a11,11,0,0,1,10.94-10.94h25a11,11,0,0,1,10.94,10.94v5.91A11,11,0,0,1,712.11,93.6Zm-25-21.23a4.39,4.39,0,0,0-4.38,4.38v5.91A4.39,4.39,0,0,0,687.09,87h25a4.39,4.39,0,0,0,4.38-4.38V76.75a4.39,4.39,0,0,0-4.38-4.38Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 699.6,
    y1: 164.51,
    x2: 699.6,
    y2: 276.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 723.05,
    y1: 164.51,
    x2: 723.05,
    y2: 276.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 746.5,
    y1: 164.51,
    x2: 746.5,
    y2: 272.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 654.52,
    y1: 164.51,
    x2: 654.52,
    y2: 273.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 677.97,
    y1: 164.51,
    x2: 677.97,
    y2: 276.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.56,581.53h0A143.26,143.26,0,0,0,108,399.62h0a21,21,0,0,0-26.63,13.1h0a143.26,143.26,0,0,0,89.54,181.91h0A21,21,0,0,0,197.56,581.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.54,510.87C96.93,481.18,92.83,448.53,100,418.93a1.1,1.1,0,0,1,1.57-.78c27.84,12.37,51.21,35.54,65.82,65.22A144.23,144.23,0,0,1,181.62,532a126.82,126.82,0,0,1-2.68,43.35,1.1,1.1,0,0,1-1.57.78A126,126,0,0,1,144.93,555a145.37,145.37,0,0,1-33.39-44.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M121.54,404.87a82.63,82.63,0,0,0-44.65,23.66,143.15,143.15,0,0,0-3.26,30.66,84.62,84.62,0,0,1,30.83-26A85.91,85.91,0,0,1,154,425.41,142.73,142.73,0,0,0,121.54,404.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M201.55,567.42a82.62,82.62,0,0,1-46,21,143.48,143.48,0,0,1-26.28-16.11,84.58,84.58,0,0,0,39.37-8.61,85.79,85.79,0,0,0,36.43-34.51A142.59,142.59,0,0,1,201.55,567.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149.13,508.7c-.46-1.61-35.13-64.36-35.13-64.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 133.41,
    y1: 499.2,
    x2: 150.38,
    y2: 490.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 126.53,
    y1: 486.6,
    x2: 143.51,
    y2: 477.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 119.65,
    y1: 473.99,
    x2: 136.63,
    y2: 464.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 112.78,
    y1: 461.38,
    x2: 129.75,
    y2: 452.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.39,434.2s27.54,23.3,35.54,54.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 202.57,
    y: 407.99,
    width: 189.83,
    height: 189.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 224.57,
    y: 416.94,
    width: 189.83,
    height: 189.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 242.48,
    y: 429.02,
    width: 189.83,
    height: 189.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 337.4,
    cy: 523.94,
    r: 80.59,
    transform: "translate(-271.66 392.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M382.49,477.44s38.43,13.27,18.33,78.92"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 337.4,
    cy: 523.94,
    r: 33.71,
    transform: "translate(-249.34 733.91) rotate(-76.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 79.14,
    y: 511.29,
    width: 265.46,
    height: 201.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 344.6,
    y: 511.29,
    width: 100.68,
    height: 201.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "317.41 564.52 49.69 564.52 75.67 511.29 344.6 511.29 317.41 564.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "486.86 564.52 386.18 564.52 344.6 511.29 445.28 511.29 486.86 564.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 293.96,
    y: 594.69,
    width: 51.05,
    height: 24.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 394.23,
    y: 688.5,
    width: 51.05,
    height: 24.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 79.14,
    y: 646.99,
    width: 49.48,
    height: 24.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 344.6,
    y1: 712.67,
    x2: 344.6,
    y2: 511.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M870.8,345.37a2.83,2.83,0,0,1,5,2.41C847.6,449.62,808.74,548.24,770,646.6c-3.08,7.81-6.37,16.84-12.94,22.37-3.41-21.17,2.6-45.91,6.15-66.85a611.16,611.16,0,0,1,16.28-70.53,617.77,617.77,0,0,1,56.27-132.13Q845.77,381.9,857,365C860,360.53,865.77,352.36,870.8,345.37Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 765.95,
    y1: 632.27,
    x2: 871.79,
    y2: 349.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M649.13,348.11a2.83,2.83,0,0,0-5,2.41C672.34,452.36,711.2,551,750,649.33c3.09,7.82,6.38,16.84,12.94,22.37,3.42-21.17-2.59-45.9-6.14-66.85a612.63,612.63,0,0,0-16.29-70.52,616.63,616.63,0,0,0-56.27-132.14q-10-17.55-21.23-34.42C660,363.27,654.17,355.09,649.13,348.11Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 753.98,
    y1: 635,
    x2: 648.15,
    y2: 352.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M762.35,299a2.83,2.83,0,0,1,5.54.61c7.26,105.42,3.43,211.32-.41,317-.3,8.4-.41,18-4.76,25.39-10.26-18.83-12.82-44.16-16.45-65.09A609.14,609.14,0,0,1,738.16,505a616.62,616.62,0,0,1,9.1-143.29q3.63-19.89,8.57-39.51C757.15,316.92,759.92,307.27,762.35,299Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 758.93,
    y1: 604.39,
    x2: 764.68,
    y2: 302.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M805.76,711.76H702.13a43.08,43.08,0,0,1-43.12-43h0a43.08,43.08,0,0,1,43.12-43H805.76a43.08,43.08,0,0,1,43.12,43h0A43.08,43.08,0,0,1,805.76,711.76Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 674.24,
    y1: 637.13,
    x2: 835.03,
    y2: 637.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 665.47,
    y1: 648.25,
    x2: 842.46,
    y2: 648.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M627.71,455.35A229.72,229.72,0,0,1,606.88,444a8,8,0,0,0-.54,1.72c-1.46,7.88-12.08,52.81-64.39,60.7C553.26,511.76,603.05,530.35,627.71,455.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M657.66,467.93a301.28,301.28,0,0,1-29.95-12.58c-24.66,75-74.45,56.41-85.76,51a110.57,110.57,0,0,1-16.72,1.18,12.52,12.52,0,0,0-12.46,10.88c0,.3-.07.6-.09.91a10.29,10.29,0,0,0,4.53,9.23c10.49,7.09,41.39,23.06,94,10.9l.59-.11c.74-.11,2.79-.39,5.64-.75,7.09-34.94,29.28-39.77,37.26-40.36-1.12-9.32-1.35-21.12,2.66-29.5A7.76,7.76,0,0,0,657.66,467.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654,457.88a154.46,154.46,0,0,0-23.09-13.14,60,60,0,0,0-16.36-5,7.35,7.35,0,0,0-6.62,2.64l-.12.14a7.46,7.46,0,0,0-.88,1.46,229.72,229.72,0,0,0,20.83,11.38,301.28,301.28,0,0,0,29.95,12.58,5.91,5.91,0,0,0,.29-1.19v-.08A9.31,9.31,0,0,0,654,457.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M637.13,555.45A13.19,13.19,0,1,1,624.3,541.9,13.19,13.19,0,0,1,637.13,555.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M553.83,555.18A13.19,13.19,0,1,1,541,541.63,13.19,13.19,0,0,1,553.83,555.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M657.6,514c-.11-.55-.25-1.09-.38-1.63a116.25,116.25,0,0,1-2.56-14.07c-8,.59-30.17,5.42-37.26,40.36,7.28-.93,19.81-2.34,29.26-2.5a11,11,0,0,0,10.4-7.74A28.82,28.82,0,0,0,657.6,514Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M646.67,536.07c-13.23.21-32.53,2.91-34.94,3.25l-.5.1c-46.27,10.71-75.75-.36-89.32-8l-.58-.32c-1.87-1.08-3.43-2.09-4.65-2.94a9.38,9.38,0,0,1-2.7-2.88l-1.07,5.44a9.5,9.5,0,0,0,2.69,2.89l.68.45c.61.41,1.28.85,2,1.31l-2,5.32a3.54,3.54,0,0,0,2,4.57l5.14,2.08a3.56,3.56,0,0,0,4.8-2.5l.9-3.93c2.42,1,5.1,2.05,8,3h0l-2.23,6.51,24.16,4.91,2.51-6.54c13.4,1.2,29.57.48,48.58-3.92l.52-.1c.74-.1,3.05-.43,6.26-.83l3.24-.29-.33,8.87,24.52-3,.59-8.09,4.24-.38a6.49,6.49,0,0,0,5.42-4q.46-1.08.93-2.13a10.53,10.53,0,0,0,.46-1.22,26.77,26.77,0,0,0,1.07-5.43A11.07,11.07,0,0,1,646.67,536.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M646.27,555.69a13.19,13.19,0,1,1-12.83-13.54A13.2,13.2,0,0,1,646.27,555.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M560,555.35A13.19,13.19,0,1,1,547.2,541.8,13.19,13.19,0,0,1,560,555.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M619.84,552.51a14.94,14.94,0,0,0,8.34,15.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M535.81,547.74s-7,14,7.58,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M552.37,555.14a5.53,5.53,0,1,1-5.38-5.68A5.54,5.54,0,0,1,552.37,555.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M638.61,555.49a5.53,5.53,0,1,1-5.38-5.68A5.53,5.53,0,0,1,638.61,555.49Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 566.57,
    y1: 498.84,
    x2: 576.04,
    y2: 503.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 575.1,
    y1: 493.69,
    x2: 584.57,
    y2: 498.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 581.95,
    y1: 488.5,
    x2: 591.43,
    y2: 493.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 588.11,
    y1: 482.24,
    x2: 597.58,
    y2: 487.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 593.08,
    y1: 475.95,
    x2: 602.55,
    y2: 481.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M612.33,442.47c.39.41,24.46,16.25,41.67,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M514.18,514.09c1.37,1.2,18.27,13.63,50.64,14.72A59.92,59.92,0,0,0,613.63,506c9.14-11.48,23-23.49,40.39-22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 494.31,
    y: 574.9,
    width: 155.86,
    height: 136.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 480.99,
    y: 568.53,
    width: 178.57,
    height: 17.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 624.7,
    y: 595.55,
    width: 25.47,
    height: 13.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 494.31,
    y: 663.5,
    width: 35.08,
    height: 22.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "499.89 472.76 505.65 464.35 511.45 472.8 519.83 478.52 511.41 484.29 505.65 492.7 499.89 484.29 491.47 478.52 499.89 472.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "665.52 548.18 669.37 542.56 673.24 548.21 678.84 552.03 673.22 555.88 669.37 561.51 665.52 555.88 659.89 552.03 665.52 548.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "553.35 413.7 557.2 408.08 561.08 413.73 566.67 417.56 561.05 421.41 557.2 427.03 553.35 421.41 547.73 417.56 553.35 413.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 1,
    y1: 712.67,
    x2: 917.82,
    y2: 712.67
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImage1);
export default __webpack_public_path__ + "static/media/banner-image-1.ea2bd83ffb08a934b828d1363a994878.svg";
export { ForwardRef as ReactComponent };